<template>
  <div>
    <div class="fixed-top teamioAnnouncement" v-if="announcementToShow" ref="teamioAnnouncement">
      <span v-html="this.announcementToShow.text"/>
      <a href="#" class="announcement-logout-link" @click.prevent="Logout">
        <i class="la la-sign-out" /> Log Out
      </a>
    </div>
    <b-navbar class="header d-print-none header-mobile">
      <b-nav class="header-main-nav">


       
        <b-nav-item id="overdue_recall" class="" v-if="$can('view', 'overdue_recall') || $can('view', 'all')">
          <!--
          <router-link to="/app/OverdueRecall" tag="span" >
            <b-button variant="transparent" class="btn-navbar-head">Overdue Recall</b-button>
          </router-link>
          -->
          <router-link :to="{ name: 'OverdueRecall', params: { lists: this.lists} }" tag="span">
            <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-time text-success mr-xs" style="margin-bottom:.5em;"></i>Overdue Recall</b-button>
          </router-link>
        </b-nav-item>  
        
        <b-nav-item class="" v-if="$can('view', 'unscheduled_treatment') || $can('view', 'all')">
        <!-- <b-nav-item class=""> -->
          <!--
          <router-link to="/app/OverdueRecall" tag="span" >
            <b-button variant="transparent" class="btn-navbar-head">Unscheduled/Planned Tx</b-button>
          </router-link>
          -->
          <router-link id='unscheduledTreatment' :to="{ name: 'unscheduledTreatment', params: { lists: this.lists, masterList: this.masterList} }" tag="span">
            <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-list text-success mr-xs" style="margin-bottom:.5em;"></i>Unscheduled Tx</b-button>
          </router-link>
        </b-nav-item>

        <b-nav-item id="Aging" class=""  v-if="$can('view', 'outstanding_claim') || $can('view', 'all')">
        <!-- <b-nav-item class=""> -->
          <router-link :to="{ name: 'Aging', params: { claims: this.claims} }" tag="span" >
            <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-usd text-success mr-xs" style="margin-bottom:.5em;"></i>Aging</b-button>
          </router-link>
        </b-nav-item>
        
        <b-nav-item class="" v-if="$can('view', 'broken_appointment') || $can('view', 'all')">
        <!-- <b-nav-item class=""> -->
          <router-link id="BrokenAppointments" :to="{ name: 'BrokenAppointments'}" tag="span" >
            <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-remove-circle text-success mr-xs" style="margin-bottom:.5em;"></i>Broken Appointments</b-button>
          </router-link>
        </b-nav-item>


        
        <!--
        <b-nav-item class="" v-if="$can('view', 'asap_list') || $can('view', 'all')">      
          <router-link id="AsapList" :to="{ name: 'AsapList'}" tag="span" >
            <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-remove-circle text-success mr-xs" style="margin-bottom:.5em;"></i>ASAP List</b-button>
          </router-link>
        </b-nav-item>
        -->

        <!--
        <b-nav-item class="" v-if="$can('view', 'appt_reminder') || $can('view', 'all')">      
          <router-link id="AptReminder" :to="{ name: 'AptReminder'}" tag="span" >
            <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-remove-circle text-success mr-xs" style="margin-bottom:.5em;"></i>Appointment Reminder</b-button>
          </router-link>
        </b-nav-item>
        -->
        
       </b-nav>

       <b-nav class="teamio-mobile-header">

        <!-- Always-visible while masking is on. Two jobs: you never leave it on
             by accident after a recording, and anyone watching can see the data
             on screen is not real. -->
        <b-nav-item v-if="phiMaskOn" class="phi-mask-pill-item">
          <span class="phi-mask-pill" title="Patient data is faked. Outbound sends are blocked.">
            <i class="la la-eye-slash" /> DEMO MASK ON
          </span>
        </b-nav-item>

        <b-nav-item-dropdown class="fw-semi-bold btn-navbar-head teamio-menu-dropdown" no-caret>
          <!-- The label used to sit INSIDE <i class="fa fa-bars">, which gave it FontAwesome's
               font-family — letters the icon font lacks fell back to the browser serif. It now
               shortens with the width so the search box beside it keeps its room:
               ≥992 full label, 768–991 "Menu", phones the icon alone. -->
          <template slot="button-content">
            <span class="teamio-menu-toggle" aria-label="Patient lists and account menu">
              <i class="fa fa-bars" aria-hidden="true"></i>
              <span class="fw-semi-bold ml-3 d-none d-lg-inline">Patient Lists / My Account</span>
              <span class="fw-semi-bold ml-2 d-none d-md-inline d-lg-none">Menu</span>
            </span>
          </template>
          <b-dropdown-item class="" v-if="$can('view', 'overdue_recall') || $can('view', 'all')">
            <router-link :to="{ name: 'OverdueRecall', params: { lists: this.lists} }" tag="span">
              <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-time text-success mr-xs" style="margin-bottom:.5em;"></i>Overdue Recall</b-button>
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item class="" v-if="$can('view', 'unscheduled_treatment') || $can('view', 'all')">
            <router-link id='unscheduledTreatment' :to="{ name: 'unscheduledTreatment', params: { lists: this.lists, masterList: this.masterList} }" tag="span">
              <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-list text-success mr-xs" style="margin-bottom:.5em;"></i>Unscheduled Tx</b-button>
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item class=""  v-if="$can('view', 'outstanding_claim') || $can('view', 'all')">
            <router-link :to="{ name: 'Aging', params: { claims: this.claims} }" tag="span" >
              <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-usd text-success mr-xs" style="margin-bottom:.5em;"></i>Aging</b-button>
            </router-link>
          </b-dropdown-item>
          <b-dropdown-item v-if="$can('view', 'broken_appointment') || $can('view', 'all')">
            <router-link id="BrokenAppointments" :to="{ name: 'BrokenAppointments'}" tag="span" >
              <b-button variant="transparent" class="fw-semi-bold btn-navbar-head"><i class="glyphicon glyphicon-remove-circle text-success mr-xs" style="margin-bottom:.5em;"></i>Broken Appointments</b-button>
            </router-link>
          </b-dropdown-item>
          <!-- No patient search in this menu any more: it is in the header bar itself at every
               width (tablet inline, phone behind the search icon). It used to take a tap on the
               menu AND a tap on the box before staff could even type. -->
          <b-dropdown-divider />
          <b-dropdown-item>
            <span class="avatar thumb-sm float-left mr-2">
              <!-- <img class="rounded-circle" src="../../assets/people/a5.jpg" alt="..." /> -->
              <img v-if="this.user" class="rounded-circle" :src="avatarUrl" @error="onAvatarError" alt="..." />
            </span>
            
            <span v-if="this.user" class="small"><span class="fw-semi-bold">{{user.Name}}</span></span>
            <transition mode="out-in"
              appear
              enter-active-class="animated bounceIn"
              leave-active-class="animated bounceOut"
              :duration="200">
                <span key="notification-badge" class="ml-1 circle bg-danger text-white fw-bold" v-if="notificationCountToShow > 0">{{notificationCountDisplay}}</span>
            </transition>
          </b-dropdown-item>

          <!-- Current Clinic Name -->
          <b-dropdown-item v-if="currentSiteName" disabled class="clinic-name-item">
            <i class="la la-building mr-2"></i>
            <span class="fw-semi-bold">{{ currentSiteName }}</span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="currentSiteName" />

          <b-dropdown-item-button v-if="$can('view', 'myaccount')" @click="GoToMyAccount">View My Account</b-dropdown-item-button>
          <b-dropdown-item-button @click="GoToSettings" v-if="isAdminOrAbove">Settings</b-dropdown-item-button>
          <b-dropdown-item-button v-if="isSuperAdmin" data-test="header-new-navigation" @click="useNewNavigation">New navigation</b-dropdown-item-button>
          <!-- Office users (never a Super Admin): the ONE classic / new Teamio switch (uiVersion.js officeSwitchState). -->
          <b-dropdown-item-button v-if="officeSwitch.visible" data-test="header-office-switch" @click="goOfficeSwitch(officeSwitch.target)">{{ officeSwitchText }}</b-dropdown-item-button>

          <b-dropdown-item-button @click="showSwitchSiteDialog" v-if="hasMultipleSites">Switch Site</b-dropdown-item-button>

          <!-- Demo mask (Super Admin only). Per-USER, not per-site: flipping it
               masks only this browser session, so recording on a live practice's
               site does not show that practice's own staff fake patient names
               while they are trying to work. -->
          <b-dropdown-divider v-if="isSuperAdmin" />
          <b-dropdown-item-button v-if="isSuperAdmin" @click="togglePhiMask">
            <i class="la" :class="phiMaskOn ? 'la-eye-slash' : 'la-eye'" />
            Demo mask: <strong>{{ phiMaskOn ? 'ON' : 'OFF' }}</strong>
            <div class="phi-mask-hint">
              {{ phiMaskOn
                ? 'Patient names, contact info and DOB are faked. Sends are blocked.'
                : 'Fake patient data for recording. Masks this session only.' }}
            </div>
          </b-dropdown-item-button>

          <b-dropdown-item-button @click="Logout">
            <i class="la la-sign-out" /> Log Out
          </b-dropdown-item-button>

        </b-nav-item-dropdown>

        <!-- Phones (<768): a search icon next to the menu opens the full-width search bar
             below. A plain button, not b-nav-item, so the tap handler runs synchronously —
             it must focus the input inside the tap for iOS to raise the keyboard. -->
        <li v-if="headerMode === 'phone'" class="nav-item mobile-search-toggle-item">
          <button
            type="button"
            class="nav-link mobile-search-toggle"
            data-test="header-search-toggle"
            aria-label="Search patients"
            @click="openPhoneSearch"
          >
            <i class="la la-search la-lg" aria-hidden="true"></i>
          </button>
        </li>

      </b-nav>

      <!-- Tablet / 13" laptop (768–1499): the patient search in the header bar itself —
           one tap to type, one tap on the patient. Sized in Header.scss (≤1499 block): it is
           the only item that shrinks, so the bell and credit pill never wrap off the bar. -->
      <b-nav v-if="headerMode === 'tablet'" class="teamio-mobile-search-nav" data-test="header-search-panel">
        <li class="nav-item teamio-mobile-search-item">
          <HeaderPatientSearch
            variant="touch"
            v-bind="patientSearchProps"
            @select="gotoPatient"
            @photo="gotoPatientPhoto"
            @refresh="refreshPatientsList"
            @open="refreshTouchScreen"
          />
        </li>
      </b-nav>

      <!--
        Notifications bell for the mobile-collapsed header range (≤ 1499px).
        Lives in its own <b-nav> so `ml-auto` pushes it to the right edge of
        the b-navbar (the b-navbar is the flex container; b-nav children with
        ml-auto get right-aligned).

        Without this, users at ≤1499px viewports (iPad / 13" laptops /
        narrowed browsers) saw only a notification count badge inside the
        hamburger menu with no way to open the panel — Lakeshore Dental
        reported this as inaccessible task-comment notifications.
      -->
      <b-nav class="teamio-mobile-bell-nav ml-auto">
        <!-- Credit-balance pill for the collapsed header range (≤1499px — iPad / 13" laptops /
             phones). The desktop pill lives in main-header-right-side, which is hidden here, so it
             must also appear next to the mobile bell or it's invisible on tablet/mobile. -->
        <CreditBalancePill pill-id="credit-balance-pill-m" class="d-flex align-items-center mr-2" />
        <b-nav-item-dropdown
          class="notificationsMenu mobile-notifications-bell"
          extra-menu-classes="notificationsWrapper py-0 animated animated-fast fadeInUp"
          no-caret
          right>
          <template slot="button-content">
            <i class="la la-bell la-lg" aria-label="Notifications"></i>
            <transition mode="out-in"
              appear
              enter-active-class="animated bounceIn"
              leave-active-class="animated bounceOut"
              :duration="200">
              <span key="mobile-notification-badge" class="ml-1 circle bg-danger text-white fw-bold" v-if="notificationCountToShow > 0">{{notificationCountDisplay}}</span>
            </transition>
          </template>
          <Notifications/>
        </b-nav-item-dropdown>
      </b-nav>
      <!--
      <b-nav>
        <b-form class="d-sm-down-none ml-5" inline>
          <b-form-group>
            <b-input-group class="input-group-no-border">
              <div class="input-group-addon d-flex align-items-center">
                <i class="la la-search px-3" />
              </div>
              <b-input id="search-input" placeholder="Search Dashboard" />
            </b-input-group>
          </b-form-group>
        </b-form>
      </b-nav>
      -->
      <!-- <a  class="navbarBrand d-md-none">
        <i class="fa fa-circle text-gray mr-n-sm" />
        <i class="fa fa-circle text-warning" />
        &nbsp;
        hello there
        &nbsp;
        <i class="fa fa-circle text-warning mr-n-sm" />
        <i class="fa fa-circle text-gray" />
      </a> -->
      <b-nav class="main-header-right-side ml-auto">
        <!--
        <b-nav-form>
            <b-form-input size="sm" class="mr-sm-2" placeholder="Search Patients"></b-form-input>
            <b-button variant="success" size="sm" class="my-2 my-sm-0" type="submit">Search</b-button>
        </b-nav-form>
        -->
        <b-nav-form v-if="headerMode === 'desktop'">
          <HeaderPatientSearch
            variant="compact"
            v-bind="patientSearchProps"
            @select="gotoPatient"
            @photo="gotoPatientPhoto"
            @refresh="refreshPatientsList"
            @open="refreshTouchScreen"
          />
        </b-nav-form>
        <b-nav-item class="mr-3">
         <i class="la la-refresh la-lg" id="refresh-tooltip" @click="refreshPatientsList" v-if="!patientListRefreshing"/>
         <b-tooltip target="refresh-tooltip" triggers="hover">
          If you can't find the patient you're looking for, try clicking this "refresh" icon to sync any new patients that may have been added on today.
          </b-tooltip>
          <i class="fa fa-spinner fa-spin" style="font-size:18px;" v-if="patientListRefreshing"/>
        </b-nav-item>
        <!-- Desktop copy of the demo-mask indicator (the mobile b-nav above has
             its own). Always visible while masking is on: you never leave it on
             by accident after a recording, and anyone watching can see the data
             on screen is not real. -->
        <span v-if="phiMaskOn" class="phi-mask-pill mr-3" title="Patient data is faked. Outbound sends are blocked.">
          <i class="la la-eye-slash" /> DEMO MASK ON
        </span>
        <CreditBalancePill pill-id="credit-balance-pill-d" class="d-flex align-items-center mr-3" />
        <b-nav-item-dropdown
          id="basic-nav-dropdown"
          class="notificationsMenu d-sm-down-none mr-2"
          extra-menu-classes="notificationsWrapper py-0 animated animated-fast fadeInUp"
          right>
          <template slot="button-content">
            <span class="avatar thumb-sm float-left mr-2">
              <!-- <img class="rounded-circle" src="../../assets/people/a5.jpg" alt="..." /> -->
              <img v-if="this.user" class="rounded-circle" :src="avatarUrl" @error="onAvatarError" alt="..." />
            </span>
            <span v-if="this.user" class="d-inline-flex flex-column align-items-start" style="line-height: 1.2;">
              <span class="small fw-semi-bold">{{user.Name}}</span>
              <span v-if="currentSiteName" class="text-muted" :title="currentSiteName" style="font-size: 0.7em; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{ currentSiteName }}</span>
            </span>
            <transition mode="out-in"
              appear
              enter-active-class="animated bounceIn"
              leave-active-class="animated bounceOut"
              :duration="200">
                <span key="notification-badge" class="ml-1 circle bg-danger text-white fw-bold" v-if="notificationCountToShow > 0">{{notificationCountDisplay}}</span>
            </transition>
          </template>
          <Notifications/>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown class="settingsDropdown d-sm-down-none" no-caret right>
          <template slot="button-content">
            <i class="la la-cog px-2" />
          </template>
          <!-- Current Clinic Name -->
          <b-dropdown-item v-if="currentSiteName" disabled class="clinic-name-item">
            <i class="la la-building mr-2"></i>
            <span class="fw-semi-bold">{{ currentSiteName }}</span>
          </b-dropdown-item>
          <b-dropdown-divider v-if="currentSiteName" />

          <b-dropdown-item-button v-if="$can('view', 'myaccount')" @click="GoToMyAccount">View My Account</b-dropdown-item-button>
          <b-dropdown-item-button @click="GoToSettings" v-if="isAdminOrAbove">Settings</b-dropdown-item-button>
          <b-dropdown-item-button v-if="isSuperAdmin" data-test="header-new-navigation" @click="useNewNavigation">New navigation</b-dropdown-item-button>
          <!-- Office users (never a Super Admin): the ONE classic / new Teamio switch (uiVersion.js officeSwitchState). -->
          <b-dropdown-item-button v-if="officeSwitch.visible" data-test="header-office-switch" @click="goOfficeSwitch(officeSwitch.target)">{{ officeSwitchText }}</b-dropdown-item-button>

          <b-dropdown-item-button @click="showSwitchSiteDialog" v-if="hasMultipleSites">Switch Site</b-dropdown-item-button>

          <!-- Demo mask (Super Admin only). NOTE: this menu is DUPLICATED in
               this file — the `teamio-mobile-header` b-nav above has its own
               copy of these same items, and THIS gear-icon dropdown is the one
               shown on desktop (`d-sm-down-none`). Any item added to one must be
               added to the other or it is invisible at that breakpoint. -->
          <b-dropdown-divider v-if="isSuperAdmin" />
          <b-dropdown-item-button v-if="isSuperAdmin" @click="togglePhiMask">
            <i class="la" :class="phiMaskOn ? 'la-eye-slash' : 'la-eye'" />
            Demo mask: <strong>{{ phiMaskOn ? 'ON' : 'OFF' }}</strong>
            <div class="phi-mask-hint">
              {{ phiMaskOn
                ? 'Patient names, contact info and DOB are faked. Sends are blocked.'
                : 'Fake patient data for recording. Masks this session only.' }}
            </div>
          </b-dropdown-item-button>

          <!--
          <b-dropdown-item>Calendar</b-dropdown-item>
          <b-dropdown-item href="/inbox">
            Inbox &nbsp;&nbsp;<b-badge variant="danger" pill class="animated bounceIn">9</b-badge>
          </b-dropdown-item>
          -->
          <b-dropdown-divider />
          <b-dropdown-item-button @click="Logout">
            <i class="la la-sign-out" /> Log Out
          </b-dropdown-item-button>
        </b-nav-item-dropdown>
        <!--
        <b-nav-item>
          <a class="d-sm-down-none px-2" id="toggle-chat" href="#" @click="toggleChat">
            <i class="la la-globe" />
          </a>
          <div id="chat-notification" class="chatNotification hide">
            <div class="chatNotificationInner">
              <h6 class="title d-flex text-white">
                <span class="thumb-xs">
                  <img src="../../assets/people/a6.jpg" alt=""
                    class="rounded-circle mr-xs float-left" />
                </span>
                Jess Smith
              </h6>
              <p class="text">
                Hi there! <br /> This is a completely new version of Sing App <br />
                built with <strong class="text-primary">Vue</strong>
              </p>
            </div>
          </div>
        </b-nav-item>
        <b-nav-item class="fs-lg d-md-none">
          <a href="#" @click="toggleChat">
            <span class="rounded rounded-lg bg-gray text-white"><i class="la la-globe" /></span>
          </a>
        </b-nav-item>
        -->
      </b-nav>

      <!-- Phones (<768): the full-width patient search, opened by the search icon beside the
           menu. It stays RENDERED (hidden by class) for the whole of phone mode so the input
           already exists when the icon is tapped: openPhoneSearch() reveals it and focuses the
           input inside that same tap, which is the only way iOS raises the keyboard. -->
      <div
        v-if="headerMode === 'phone'"
        ref="phoneSearchBar"
        class="mobile-search-bar"
        :class="{ 'is-open': phoneSearchOpen }"
        data-test="header-search-bar-panel"
        @keydown.esc="closePhoneSearch"
      >
        <HeaderPatientSearch
          ref="phoneSearch"
          class="mobile-search-bar__field"
          variant="touch"
          v-bind="patientSearchProps"
          @select="gotoPatient"
          @photo="gotoPatientPhoto"
          @refresh="refreshPatientsList"
          @open="refreshTouchScreen"
          @close="closePhoneSearch"
        />
        <button
          type="button"
          class="mobile-search-bar__cancel"
          data-test="header-search-cancel"
          @mousedown.prevent
          @click="closePhoneSearch"
        >Cancel</button>
      </div>
    </b-navbar>
    
    <!-- Move the modal inside the main div -->
    <b-modal id="switch-site-modal" title="Switch Site" hide-footer modal-class="switch-site-modal-tall">
      <div>
        <p class="mb-3">Select a site to switch to:</p>
        <input
          v-if="userSites.length > 8"
          v-model="siteSearch"
          type="search"
          class="search-input site-search-input w-100 mb-2"
          placeholder="Search practices"
          aria-label="Search practices"
          data-test="site-switcher-search"
          :disabled="siteSwitching"
        />
        <b-dropdown
          id="site-switcher-dropdown"
          :text="selectedSiteDropdownText"
          variant="default"
          class="w-100 mb-3 site-switcher-dropdown"
          :disabled="siteSwitching"
        >
          <b-dropdown-text v-if="siteSearch && filteredUserSites.length === 0">
            No practices match "{{ siteSearch }}".
          </b-dropdown-text>
          <b-dropdown-item-button
            v-for="site in filteredUserSites"
            :key="site.SiteID"
            @click="handleSiteSelection(site)"
            :active="selectedSite && selectedSite.SiteID === site.SiteID"
          >
            <div class="option__desc">
              <span class="option__title fw-semi-bold">{{ siteCustomLabel(site) }}</span>
              <small class="d-block text-muted" v-if="site.CustomerName">{{ site.CustomerName }}</small>
            </div>
          </b-dropdown-item-button>
          <b-dropdown-divider v-if="userSites.length === 0"></b-dropdown-divider>
          <b-dropdown-text v-if="userSites.length === 0 && !siteLoading">
            No sites found.
          </b-dropdown-text>
           <b-dropdown-text v-if="userSites.length === 0 && siteLoading">
            Loading sites...
          </b-dropdown-text>
        </b-dropdown>
        
        <div class="d-flex justify-content-end mt-4">
          <b-button variant="default" class="mr-2" @click="$bvModal.hide('switch-site-modal')" :disabled="siteSwitching">
            Cancel
          </b-button>
          <b-button variant="primary" @click="confirmSwitchSite" :disabled="!selectedSite || siteSwitching">
            <b-spinner small v-if="siteSwitching" class="mr-1"></b-spinner>
            {{ siteSwitching ? 'Switching...' : 'Switch to Selected Site' }}
          </b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable */

window.mobileCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

window.mobileAndTabletCheck = function() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';
//import $ from 'jquery';
import Notifications from '@/components/Notifications/Notifications';
import CreditBalancePill from '@/components/CreditBalancePill.vue';
import CommonQueries from '../../sql/queries';
import _ from 'lodash';
import defaultAvatar from '@/assets/avatar.png';
import axios from 'axios';
import { maskState, setUserMask } from '@/utils/phiMaskState';
import HeaderPatientSearch from './HeaderPatientSearch.vue';
import { isPatientPhotoEnabled } from '@/utils/patientPhotoGate';
import { hasTouchScreen } from '@/utils/deviceType';
import { requestPhotoSheet } from '@/utils/photoSheetRequest';
import { getRecentPatNums, recordRecentPatient, parsePatientProfileID } from '@/utils/recentPatients';
import { pickSiteList, upsertSiteRow, filterSites, resolveSwitchUser, switchErrorMessage } from '@/utils/siteSwitch';
import { setNavUiChoice, browserStorage, officeSwitchState } from '@/utils/followups/uiVersion';
import { switchOfficeUi } from '@/utils/followups/uiSwitch';
import { officeSwitchLabel } from '@/utils/followups/uiCopy';

// Where the patient search MOUNTS: desktop nav (≥1500), tablet bar (768–1499) or the phone
// search bar (<768). These edges must match Header.scss's media blocks, which decide which
// navs SHOW — a mismatch leaves a band of widths with no search at all.
// Guarded by cypress/node-tests/header-patient-search-wiring.test.js.
const DESKTOP_QUERY = '(min-width: 1500px)';
const PHONE_QUERY = '(max-width: 767.98px)';

function headerModeFor(desktopMql, phoneMql) {
  if (desktopMql && desktopMql.matches) return 'desktop';
  if (phoneMql && phoneMql.matches) return 'phone';
  return 'tablet';
}

function initialHeaderMode() {
  try {
    if (typeof window === 'undefined' || !window.matchMedia) return 'desktop';
    return headerModeFor(window.matchMedia(DESKTOP_QUERY), window.matchMedia(PHONE_QUERY));
  } catch (e) {
    return 'desktop';
  }
}

export default {
  name: 'Header',
  components: { Notifications, CreditBalancePill, HeaderPatientSearch },

  mounted() {
  },

  created() {
   this.setupHeaderMode();
   this.refreshRecentPatients();
   // Load user sites first so we know if we have multiple sites
   this.loadUserSites();
   // Once per mount: the server's list replaces the login-time cache (stale, and a Teamio operator
   // can switch to sites that are not in it at all). Never from the interval below — that runs every second.
   this.refreshSwitchableSites();
   // Setup an interval to check for userSites in localStorage
   this.siteCheckInterval = setInterval(() => {
     if (!this.hasMultipleSites) {
       this.loadUserSites();
     } else {
       clearInterval(this.siteCheckInterval);
     }
   }, 1000);
   // Then initialize the rest of the component
   this.init();
  },

  data() {
    return {
      // 'desktop' | 'tablet' | 'phone' — where the patient search mounts (DESKTOP_QUERY / PHONE_QUERY).
      headerMode: initialHeaderMode(),
      phoneSearchOpen: false,
      // PatNums opened on this device for this site, newest first (utils/recentPatients.js).
      recentPatNums: [],
      // Re-read when the search opens: test runners attach touch emulation after page load.
      touchScreen: hasTouchScreen(),
      patientListRefreshing: false,
      employeeListRefreshing: false,
      userSites: [],
      selectedSite: null,
      siteSearch: '',
      siteLoading: false,
      siteSwitching: false,
      // Add a flag to track if we've loaded sites
      sitesLoaded: false,
      // Reference to interval for checking userSites
      siteCheckInterval: null
    }
  },

  methods: {
    /**
     * Flip the per-user demo mask, then RELOAD.
     *
     * The reload is not optional. Masking happens on the axios response, so
     * anything already sitting in the Vuex store was fetched before the flip and
     * is still real. Without a reload you get a half-masked screen — some rows
     * faked, some not — which is exactly the silent leak this feature exists to
     * prevent, and the worst possible thing to start recording against.
     */
    togglePhiMask() {
      const next = !this.phiMaskOn;
      const ok = window.confirm(next
        ? 'Turn the demo mask ON?\n\nPatient names, phone numbers, emails, addresses and DOB will be replaced with fake data for THIS browser session only. Outbound sends (SMS, email, campaigns, AI calls) will be blocked.\n\nThe page will reload.'
        : 'Turn the demo mask OFF?\n\nReal patient data will be shown again and sends will be re-enabled.\n\nThe page will reload.');
      if (!ok) return;
      setUserMask(next);
      window.location.reload();
    },

    ...mapActions('layout', ['toggleSidebar', 'toggleChat', 'switchSidebar', 'changeSidebarActive']),
    ...mapActions('customer', ['logout', 'getEmployees', 'getSettings', 'loadRules', 'getPatients', 'checkifPatientOrEmployeeNeedsUpdating', 'removePatientNeedsUpdating', 'removeEmployeeNeedsUpdating', 'handleSelectSite', 'selectSite', 'getSwitchableSites']),
    ...mapActions('notifications', ['getNotifications', 'addNotification']),
    ...mapActions('tasks', ['setTasks']),
    ...mapActions('chat', ['checkIfNewChatMessagesAvailable']),

    ...mapMutations('customer', ['setEmployees']),

    async init() {
      await this.getNotifications({employeeID: this.userID, siteID: this.siteID});
      if(!this.settings || this.settings.length === 0)
         await this.getSettings({siteID: this.siteID});
      if(!this.employees || this.employees.length === 0) {
         let query = {
               sqlQuery : CommonQueries.getEmployees(this.siteID)
         }
         await this.getEmployees(query);
      }
      if(!this.rules || this.rules.length === 0) {
         await this.loadRules({user: this.user, settings: this.settings});
         this.$ability.update(this.rules);
      } else {
        this.$ability.update(this.rules);
      }
      this.loadUserSites();
      // Self-heal a purged/absent patient roster (phi-mask cache reconcile or
      // localStorage quota drop). Nothing else refills it without a re-login —
      // without this, patient search and the Forms patient filter stay empty
      // for the whole session. Not awaited: the roster query is heavy and
      // refreshPatientsList handles its own spinner + errors.
      if (!this.patients || this.patients.length === 0) {
         this.refreshPatientsList();
      }
      await this.checkIfNewChatMessagesAvailable({currentUser: this.userID});
      this.checkifPatientOrEmployeeNeedsUpdating({siteID: this.siteID});
    },

    switchSidebarMethod() {
      if (!this.sidebarClose) {
        this.switchSidebar(true);
        this.changeSidebarActive(null);
      } else {
        this.switchSidebar(false);
        const paths = this.$route.fullPath.split('/');
        paths.pop();
        this.changeSidebarActive(paths.join('/'));
      }
    },

    toggleSidebarMethod() {
      if (this.sidebarStatic) {
        this.toggleSidebar();
        this.changeSidebarActive(null);
      } else {
        this.toggleSidebar();
        const paths = this.$route.fullPath.split('/');
        paths.pop();
        this.changeSidebarActive(paths.join('/'));
      }
    },

    GoToSettings() {
      this.$router.push('/app/settings');
    },


    GoToMyAccount() {
      this.$router.push('/app/my-account');
    },

    // Super Admin: back to the new app shell (Layout.vue listens for 'teamio:nav-ui'; the shell's
    // own "Classic navigation" link is the way back here).
    useNewNavigation() {
      setNavUiChoice(browserStorage(), 'new');
      this.$root.$emit('teamio:nav-ui', 'new');
    },

    // Office users: store the one classic / new choice under the employee ID, count it, reload.
    goOfficeSwitch(target) {
      switchOfficeUi(target, { userKey: this.userID, from: 'header-menu' });
    },

    // ── Patient search (HeaderPatientSearch.vue) ─────────────────────────────────────────────

    setupHeaderMode() {
      if (typeof window === 'undefined' || !window.matchMedia) return;
      const desktop = window.matchMedia(DESKTOP_QUERY);
      const phone = window.matchMedia(PHONE_QUERY);
      const onChange = () => {
        this.headerMode = headerModeFor(desktop, phone);
        if (this.headerMode !== 'phone') this.phoneSearchOpen = false;
      };
      // Safari < 14 only has the deprecated addListener.
      [desktop, phone].forEach((mql) => {
        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else if (mql.addListener) mql.addListener(onChange);
      });
      this.headerModeListener = { queries: [desktop, phone], onChange };
      onChange();
    },

    teardownHeaderMode() {
      const listener = this.headerModeListener;
      if (!listener) return;
      listener.queries.forEach((mql) => {
        if (mql.removeEventListener) mql.removeEventListener('change', listener.onChange);
        else if (mql.removeListener) mql.removeListener(listener.onChange);
      });
      this.headerModeListener = null;
    },

    refreshRecentPatients() {
      this.recentPatNums = getRecentPatNums(this.siteID);
    },

    // Every way into a profile counts — search, an Open Dental program link, a family link, a
    // task — but only for the signed-in site, so a stale link to another practice records nothing.
    trackRecentPatient(route) {
      if (!route || route.name !== 'patientprofile') return;
      const link = parsePatientProfileID(route.params && route.params.patientID);
      if (!link || !this.siteID) return;
      if (link.siteID.toLowerCase() !== String(this.siteID).toLowerCase()) return;
      this.recentPatNums = recordRecentPatient(this.siteID, link.patNum);
    },

    refreshTouchScreen() {
      this.touchScreen = hasTouchScreen();
    },

    /**
     * Must stay synchronous: reveal the bar on the element itself (Vue's class patch lands a
     * tick later) and focus the input inside this same tap, or iOS opens the list with no keyboard.
     */
    openPhoneSearch() {
      this.phoneSearchOpen = true;
      const bar = this.$refs.phoneSearchBar;
      if (bar) bar.classList.add('is-open');
      const search = this.$refs.phoneSearch;
      if (search) search.focus();
    },

    closePhoneSearch() {
      const bar = this.$refs.phoneSearchBar;
      if (!this.phoneSearchOpen && !(bar && bar.classList.contains('is-open'))) return;
      this.phoneSearchOpen = false;
      if (bar) bar.classList.remove('is-open');
      const search = this.$refs.phoneSearch;
      if (search) search.blur();
    },

    gotoPatient(patient) {
      if (!patient || patient.PatNum == null || !this.user) return;
      this.closePhoneSearch();
      const teamioPatientID = `${this.user.SiteID}-${patient.PatNum}`;
      this.$router.push(`/app/patientprofile/${teamioPatientID}`).catch((err) => {
        // Tapping the patient who is already open is a duplicate navigation — nothing to do.
        if (err && err.name !== 'NavigationDuplicated') {
          console.warn('[Header] could not open the patient profile:', err);
        }
      });
    },

    // The camera on a search result: ask that patient's profile to open its photo sheet, then go
    // there. Works for the patient already on screen too (PatientPhotoAvatar watches the request).
    gotoPatientPhoto(patient) {
      if (!patient || patient.PatNum == null) return;
      requestPhotoSheet(patient.PatNum);
      this.gotoPatient(patient);
    },
    
    async Logout() {
        await this.logout();
    },

    // Site switching methods
    loadUserSites() {
      try {
        this.siteLoading = true;
        
        // Get sites from localStorage - this is set in Login.vue when a user has multiple sites
        const storedSites = localStorage.getItem('userSites');
        
        if (storedSites && storedSites !== 'null' && storedSites !== 'undefined') {
          try {
            const parsedSites = JSON.parse(storedSites);
            // Make sure we have an array of sites with at least the current site
            if (Array.isArray(parsedSites) && parsedSites.length > 1) {  // Changed from length > 0 to > 1 to ensure multiple sites
              // Ensure we have proper site names for display
              this.userSites = pickSiteList(null, parsedSites);
            } else {
              // If only one site or not an array, use current site
              this.userSites = [this.user];
            }
          } catch (parseError) {
            console.error('Error parsing user sites:', parseError);
            this.userSites = [this.user];
          }
        } else {
          // No sites in localStorage, just use current site
          this.userSites = [this.user];
        }
        
        // Mark sites as loaded
        this.sitesLoaded = true;
        this.siteLoading = false;
        return Promise.resolve(this.userSites);
      } catch (error) {
        console.error('Error loading user sites:', error);
        this.siteLoading = false;
        // Fallback to just using current site
        this.userSites = [this.user];
        // Still mark sites as loaded even on error
        this.sitesLoaded = true;
        return Promise.reject(error);
      }
    },

    // POST /switchable-sites once; on success it becomes the cached list the 1s interval reads.
    // On failure the login-time cache stays (pickSiteList never empties the picker).
    async refreshSwitchableSites() {
      const serverSites = await this.getSwitchableSites();
      if (!Array.isArray(serverSites) || serverSites.length === 0) return;
      try {
        localStorage.setItem('userSites', JSON.stringify(serverSites));
      } catch (e) {
        console.log('Could not cache switchable sites:', e && e.message);
      }
      this.loadUserSites();
    },

    showSwitchSiteDialog() {
      // Reset selected site
      this.selectedSite = null;
      this.siteSearch = '';
      
      // Always try to reload the sites before showing the dialog
      this.siteLoading = true;
      this.loadUserSites().finally(() => {
        this.siteLoading = false;
        
        // Only show the modal if we have multiple sites
        if (this.hasMultipleSites) {
          this.$bvModal.show('switch-site-modal');
        } else {
          this.$toast.info("You only have access to one site.");
        }
      });
    },

    siteCustomLabel(site) {
      if (!site) return '';
      
      // Try different properties that might contain the site name
      const siteName = site.SiteName || site.Name || site.name;
      
      // If current site, add an indicator
      if (site.SiteID === this.siteID) {
        return `${siteName} (current)`;
      }
      
      return siteName || 'Unknown Site';
    },

    confirmSwitchSite() {
      if (this.selectedSite) {
        this.switchToSite(this.selectedSite);
      }
    },

    async switchToSite(site) {
      try {
        if (!site) {
          this.$bvModal.hide('switch-site-modal');
          return;
        }

        // Check if it's the same site
        if (site.SiteID === this.siteID) {
          this.$bvModal.hide('switch-site-modal');
          this.$toast.info("You're already on this site");
          return;
        }

        // Show spinner on button while switching
        this.siteSwitching = true;

        // Server first: it sets the session for the new site (and, for a Teamio operator, creates
        // the employee row there) and returns the row to log in with. Before 2026-09-17 this path
        // never called /select-site, so the session stayed on the login site.
        const result = await this.selectSite({ SiteID: site.SiteID, EmployeeID: site.EmployeeID });
        const user = resolveSwitchUser(result, site);
        if (!user) {
          this.$toast.error(switchErrorMessage(result) || 'There was an error switching to the site. Please try again later.');
          return;
        }
        try {
          const cached = JSON.parse(localStorage.getItem('userSites') || '[]');
          localStorage.setItem('userSites', JSON.stringify(upsertSiteRow(cached, user)));
        } catch (e) {
          console.log('Could not update cached sites:', e && e.message);
        }

        await this.handleSelectSite(user);

        // Close modal after switch completes (navigation handled in store action)
        this.$bvModal.hide('switch-site-modal');
      } catch (error) {
        console.error('Error switching site:', error);
        this.$toast.error('There was an error switching to the site. Please try again later.');
      } finally {
        this.siteSwitching = false;
      }
    },

    async refreshPatientsList() {
      try {
        this.patientListRefreshing = true;
        await this.getPatients({siteID: this.siteID});
        this.patientListRefreshing = false;
      } catch(err) {
        this.patientListRefreshing = false;
      }
    },

    async refreshEmployeeList() {      
      try {
        this.employeeListRefreshing = true;        

        let query = {
          sqlQuery : CommonQueries.getEmployees(this.siteID),
        }
        
        await this.getEmployees(query);
        this.employeeListRefreshing = false;
      } catch(err) {
        this.employeeListRefreshing = false;
      }
    },
    onAvatarError(event) {
      event.target.src = defaultAvatar;
    },

    handleSiteSelection(site) {
      this.selectedSite = site;
    },
  },

  computed: {
    // Demo session (customer/isDemo): no classic-Teamio prompts, the demo shows the new Teamio only (Saumil 8a).
    // Store-safe: component tests mount without a store or without getters.
    viewerIsDemo() {
      const store = this.$store;
      return !!(store && store.getters && store.getters['customer/isDemo'] === true);
    },
    ...mapGetters({
      notificationsCount: "notifications/count",
      notificationsLastCleared: "notifications/lastCleared",
      allMyTasksDueToday: "tasks/allMyTasksDueToday",
      getSite: 'customer/getSite',
    }),

    ...mapState('layout', {
      sidebarClose: state => state.sidebarClose,
      sidebarStatic: state => state.sidebarStatic,
    }),

    ...mapState('notifications', {
      notifications : state => state.notifications,
      notifications1 : state => state.tempNotifications1,
      notifications2 : state => state.tempNotifications2,
      notifications3 : state => state.tempNotifications3,
    }),

    ...mapState({
        tasks: state => state.tasks.tasks,
        masterList: state => state.lists.masterList,
        lists: state => state.lists.lists,
        claims: state => state.teamio.claims,
        user: state => state.customer.user,
        userID: state => state.customer.userID,
        siteID: state => state.customer.siteID,
        employees: state => state.customer.employees,
        settings: state => state.customer.settings,
        rules: state => state.customer.rules,
        patients: state => state.customer.patients,
        patientNeedsUpdating: state => state.customer.patientNeedsUpdating,
        employeeNeedsUpdating: state => state.customer.employeeNeedsUpdating,
        // V2 Conversations state (V1 removed)
        conversationsV2Rooms: state => state.conversationsV2.rooms,
    }),

    allSettings() {
      if(this.settings)
        return _.keyBy(this.settings, 'Property');
    },

    notificationCountToShow() {
      // Always return a number, never undefined
      return this.notificationsCount || 0;
    },
    // Visual cap: above 10 we render "10+" so the badge stays readable
    // and stops looking like an alarming to-do list (which led people to
    // ignore it). Underlying count is still in notificationCountToShow.
    notificationCountDisplay() {
      const n = this.notificationCountToShow;
      return n > 10 ? '10+' : n;
    },

    announcementToShow() {
      let ret = this.notifications.filter(n => n.type === 'ANNOUNCEMENT');
      if(ret.length > 0)
        return ret[0];
    },

    dateFormatStr() {
      let _default = 'MM/DD/YYYY';
      let site = this.getSite(this.siteID);
      if(site) {
        return site.DateFormat || _default;
      } else
        return _default;
    },
    currentSiteName() {
      // Try to get site name from getSite getter first
      let site = this.getSite(this.siteID);
      if (site) {
        return site.SiteName || site.Name || site.name || null;
      }
      // Fallback to user object (which is the site object from login)
      if (this.user) {
        return this.user.SiteName || this.user.Name || this.user.name || null;
      }
      // Fallback to localStorage if Vuex state not loaded
      try {
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser) {
          return storedUser.SiteName || storedUser.Name || storedUser.name || null;
        }
      } catch (e) {
        // ignore parse errors
      }
      return null;
    },
    avatarUrl() {
      return this.user && this.user.picture ? this.user.picture : defaultAvatar;
    },
    
    hasMultipleSites() {
      if (this.$store && this.$store.getters['customer/isDemo'] === true) return false; // a demo session never switches site
      // Check if we have loaded multiple sites from localStorage
      const hasMultiple = this.sitesLoaded && this.userSites && this.userSites.length > 1;
      
      // Double-check localStorage directly as a fallback
      if (!hasMultiple) {
        const storedSites = localStorage.getItem('userSites');
        if (storedSites && storedSites !== 'null' && storedSites !== 'undefined') {
          try {
            const parsedSites = JSON.parse(storedSites);
            if (Array.isArray(parsedSites) && parsedSites.length > 1) {
              // If we find multiple sites, trigger a reload of the sites
              if (!this.sitesLoaded || this.userSites.length <= 1) {
                this.loadUserSites();
              }
              return true;
            }
          } catch (e) {
            // Silent fail, just return the original check result
          }
        }
      }
      
      return hasMultiple;
    },

    filteredUserSites() {
      return filterSites(this.userSites, this.siteSearch);
    },

    selectedSiteDropdownText() {
      if (this.selectedSite) {
        return this.siteCustomLabel(this.selectedSite);
      }
      return 'Select Site';
    },
    unreadConversationsCount() {
      // CLIENT-SIDE READ/UNREAD SYSTEM: Compute unread conversations from V2 Vuex state
      if (this.conversationsV2Rooms && Array.isArray(this.conversationsV2Rooms)) {
        const totalUnread = this.conversationsV2Rooms.reduce((sum, room) => {
          const unreadCount = parseInt(room.unreadCount) || 0;
          return sum + unreadCount;
        }, 0);
        return totalUnread;
      }
      return 0;
    },

    isSuperAdmin() {
      return this.user && this.user.Role === 'Super Admin';
    },

    // { visible, target } for the office users' single classic / new switch (never visible for a
    // Super Admin, nor in the demo). localStorage is not reactive, but an office switch reloads the page.
    officeSwitch() {
      return officeSwitchState({ isSuperAdmin: !!this.isSuperAdmin, storage: browserStorage(), userKey: this.userID, isDemo: this.viewerIsDemo === true });
    },
    officeSwitchText() {
      return officeSwitchLabel(this.officeSwitch.target);
    },

    /**
     * Demo mask state. Reads the reactive store in utils/phiMaskState so the
     * pill and the menu label stay in sync with what the axios interceptor is
     * actually doing. True when EITHER the per-user toggle or the site-wide
     * GENERAL_DEMO_MODE_ON is on.
     */
    phiMaskOn() {
      const s = maskState();
      return s.userMask === true || s.siteMask === true;
    },
    isAdminOrAbove() {
      return this.user && (this.user.Role === 'Super Admin' || this.user.Role === 'Admin');
    },

    /**
     * The camera on each search result is gated exactly like the avatar sheet it opens: the site
     * is on All-in-One (the one shared rule), there is a touch screen to take the photo with, and
     * the demo mask is off (a face cannot be faked, so the avatar refuses to open while masked).
     */
    patientPhotoShortcut() {
      return isPatientPhotoEnabled(this.allSettings) && this.touchScreen && !this.phiMaskOn;
    },

    // Everything the three HeaderPatientSearch mounts share; only `variant` differs per width.
    patientSearchProps() {
      return {
        patients: this.patients || [],
        dateFormat: this.dateFormatStr,
        recentPatNums: this.recentPatNums,
        photoShortcut: this.patientPhotoShortcut,
        refreshing: this.patientListRefreshing,
      };
    },
  },

  watch: {
    // Header outlives the fullPath-keyed <router-view>, so it sees every profile visit.
    $route: {
      immediate: true,
      handler(to) {
        this.trackRecentPatient(to);
      },
    },

    siteID() {
      this.refreshRecentPatients();
    },

    patientNeedsUpdating(newValue, oldValue) {        
      if(newValue) {
        this.refreshPatientsList();
        this.removePatientNeedsUpdating({siteID: this.siteID});
      }        
    },

    employeeNeedsUpdating(newValue, oldValue) {        
      if(newValue) {
        this.refreshEmployeeList();
        this.removeEmployeeNeedsUpdating({siteID: this.siteID});
      }        
    },
    
    // Watch for user changes to reload sites
    user: {
      handler(newUser) {
        if (newUser && newUser.CustomerID) {
          this.loadUserSites();
        }
      },
      deep: true
    }
  },

  beforeDestroy() {
    if (this.siteCheckInterval) {
      clearInterval(this.siteCheckInterval);
    }
    this.teardownHeaderMode();
  }
};
</script>

<style lang="scss" scoped>

.option__small {
  font-size: 10px;
}

.switch-site-modal-tall .modal-dialog {
  max-width: 500px; /* Default for md, can be adjusted */
}

.switch-site-modal-tall .modal-content {
  min-height: 400px; /* Adjust as needed */
}

.site-search-input {
  padding: 6px 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 0.9rem;
}

/* A Teamio operator sees every active practice (~30): keep the menu inside the viewport.
   No boundary="window" on the b-dropdown: it adds .position-static, so `width: 100%` measured the
   whole modal body and the menu ran 17px off a 375px phone screen (2026-10-17). */
.site-switcher-dropdown ::v-deep .dropdown-menu {
  width: 100%;
  max-height: 50vh;
  overflow-y: auto;
}

.clinic-name-item {
  font-size: 0.85rem;
  color: #6c757d;
  cursor: default !important;
  pointer-events: none;
}

/* ── Demo mask ──────────────────────────────────────────────────────────────
 * Amber rather than the brand teal (#0f7259): this is a state warning, not a
 * feature, and it must not read as "normal". Kept small and calm so it does not
 * dominate a training video, but never hidden — the whole point is that you
 * cannot leave the mask on (or off) without noticing. */
.phi-mask-pill-item {
  display: flex;
  align-items: center;
}

.phi-mask-pill {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.15rem 0.6rem;
  border-radius: 999px;
  background: #fff4d6;
  border: 1px solid #e0a800;
  color: #7a5200;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  white-space: nowrap;
  cursor: default;
}

.phi-mask-hint {
  font-size: 0.72rem;
  line-height: 1.25;
  color: #6c757d;
  white-space: normal;
  max-width: 17rem;
  margin-top: 0.15rem;
}

</style>
<style src="./Header.scss" lang="scss" scoped />
